//Xử lý cho việc show keyboard
export const handleFocusTextInput = () => {
    if (document.getElementsByClassName("buttonNext")[0]) {
        document.getElementsByClassName("buttonNext")[0].style.marginBottom = "300px";
    }
};